export default {
  // 页面标题
  title: 'Plan',
  
  // 百万美元补贴
  millionDollarSubsidy: 'Aha Million-Dollar Subsidy',
  
  // 按需付费部分
  payAsYouGo: {
    title: 'Pay as you go',
    influencerMarketingBudget: 'Influencer marketing budget',
    aiMarketerCosts: 'AI employee costs',
    total: 'Total'
  },
  
  // 退款政策
  refund: {
    title: '100% refund',
    conditions: {
      contentDelivery: 'if influencers fail to deliver the content',
      nonOrganicPerformance: 'if influencers boost performance with non-organic views / engagements',
      overdueSubmission: 'if influencers\' submission is overdue',
      aiGeneratedContent: 'if influencers\' content does not deliver value or is fully AI-generated'
    }
  },
  
  // 预算选项
  budgetOptions: {
    monthly: 'USD / mo'
  }
};
